import React, { useCallback } from 'react';
import { Box, Divider } from '@mui/material';
import { radius } from 'themes/radius';
import { Modal } from 'components/Modal/Modal';
import { useSettingsModal } from 'contexts/SettingsModalContext/useSettingsModal';
import { SettingsSection } from 'features/settings/types/types';
import { SettingsModalContent } from '../Modal/SettingsModalContent';
import { DrawerContentSections } from './DrawerContentSections';

interface DrawerContentsProps {
  isDesktop: boolean;
  sections: SettingsSection[];
  currentSectionId: string;
}

export const DrawerContents: React.FC<DrawerContentsProps> = ({
  isDesktop,
  sections,
  currentSectionId,
}) => {
  const { modalTitle, isModalOpen, modalTitleId, onCloseModal, settingSectionId } =
    useSettingsModal();

  const shouldShowSection = (sectionId: string) =>
    // Show the section if it's the current section or if we're on a mobile/tablet device
    !isDesktop || currentSectionId === sectionId;
  const isLastSection = useCallback(
    (sectionId: string) => sectionId === sections.at(-1)?.id,
    [sections],
  );

  return (
    <Box height="100%" width="100%" padding={isDesktop ? 4 : 0} boxSizing="border-box">
      <Box
        id="drawer__content"
        height="100%"
        bgcolor="common.white"
        borderRadius={isDesktop ? radius.xxs : radius.none}
        padding={isDesktop ? 6 : 4}
        boxSizing="border-box"
      >
        {sections.map((section) => (
          <Box
            key={section.id}
            id={section.id}
            display={shouldShowSection(section.id) ? 'block' : 'none'}
          >
            <DrawerContentSections sectionId={section.id} />
            {!isDesktop && !isLastSection(section?.id) && <Divider sx={{ marginY: 3 }} />}
          </Box>
        ))}
        {!isDesktop && (
          <Modal
            open={isModalOpen}
            onClose={onCloseModal}
            showHeader
            modalTitle={modalTitle}
            modalTitleId={modalTitleId}
            disableEnforceFocus
          >
            <SettingsModalContent sectionId={settingSectionId} />
          </Modal>
        )}
      </Box>
    </Box>
  );
};
